"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_axios_error_1 = require("./is-axios-error");
/**
 * Determines if an axios error was the result of an expired/missing/invalid
 * access token.
 */
const isAccessTokenError = (error) => { var _a; return (0, is_axios_error_1.isAxiosError)(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401; };
exports.default = isAccessTokenError;
